import { StripeError } from '@stripe/stripe-js'

export default function handleStripeError(error: StripeError) {
  switch (error.decline_code || error.code) {
    case 'generic_decline':
      return `Your card was declined, please try again.`
    case 'insufficient_funds':
      return `Your card has insufficient funds, please try again.`
    case 'lost_card':
      return `An error has occurred while trying to finalize your payment.`
    case 'stolen_card':
      return `An error has occurred while trying to finalize your payment.`
    case 'expired_card':
      return `Your card has expired, please try again.`
    case 'incorrect_cvc':
      return `Your card's security code is incorrect, please update and try again.`
    case 'processing_error':
      return `An error occurred while processing your card. Please try again in a little bit.`
    case 'card_velocity_exceeded':
      return `Your card was declined for making repeated attempts too frequently or exceeding its amount limit. Please try again in a little bit.`
    default:
      return `An error has occurred while trying to finalize your payment.`
  }
}
